<section class="payment-list-cntr container-fluid py-2">
  <form class="d-flex justify-content-between align-items-start">
    <div class="col-12 col-md-3">
      <input class="p-1 fs-sm" type="search" placeholder="جستجو" name="keyword" [(ngModel)]="criteria.q">
    </div>
    <div class="col-12 col-md-7 row">
      <app-date-range sranges="today,yesterday,last7days,last30days,last90days,last180days,last365days"
			default-range="last7days" [(start)]="criteria.fromTime" [(end)]="criteria.toTime"></app-date-range>
    </div>
    <button class="col-12 col-md-2 btn btn-secondary btn-sm" (click)="load()">جستجو</button>
  </form>
  <div class="col-12 text-center">
    <app-pagination [total]="total" [limit]="criteria.limit"></app-pagination>
  </div>
  <div class="p-1 table-responsive">
    <table class="w-100 table table-striped table-sm fs-sm">
      <thead>
        <tr>
          <td>سرویس</td>
          <td>تاریخ</td>
          <td>نام</td>
          <td>موبایل</td>
          <td>استان</td>
          <td>شهر</td>
          <td>پیشتاز</td>
          <td>توضیحات</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of list">
          <td>{{item.Request.ServiceType}}</td>
          <td>{{item.Request.RegisterTime|pdate:'[yyyy]/[mm]/[dd]'}}</td>
          <td>{{item.Name}}</td>
          <td>{{item.Username}}</td>
          <td>{{item.State}}</td>
          <td>{{item.City}}</td>
          <td>{{!item.ExpiredPromote|json}}</td>
          <td>
            <pre>{{item.Request.Message}}</pre>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center">
    <app-pagination [total]="total" [limit]="criteria.limit"></app-pagination>
  </div>
</section>